// import './global.css';
import App from './App.svelte';

const app = new App({
    target: document.getElementById("change_of_major")
});

export default {app};